import { Component, Input, model, ModelSignal, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-exam-layout',
    templateUrl: './exam-layout.component.html',
    styleUrls: ['./exam-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class ExamLayoutComponent {

	@Input() public includeQuestionSideBar: boolean = true;
	@Input() public flex: boolean = false;
  public sideBarCollapsed: ModelSignal<boolean>= model<boolean>(false);

}
